const paymentMethodsHR = {
    "view": {
        "table": {
            "title": "Popis vaših načina plaćanja",
            "column": {
                "cardholder_name": "Ime vlasnika kartice",
                "card_number": "Broj kartice",
                "expiry_month": "Mjesec isteka",
                "expiry_year": "Godina isteka",
                "type": "Tip",
                "status": "Status",
                "action": "Akcija"
            },
            "label": {
                "is_default": "Zadano",
                "is_secondary": "Sekundarno",
                "is_valid": "Važeće",
                "is_expired": "Isteklo",
                "not_available": "Nije dostupno",
                "month_january": "Siječanj",
                "month_february": "Veljača",
                "month_march": "Ožujak",
                "month_april": "Travanj",
                "month_may": "Svibanj",
                "month_june": "Lipanj",
                "month_july": "Srpanj",
                "month_august": "Kolovoz",
                "month_september": "Rujan",
                "month_october": "Listopad",
                "month_november": "Studeni",
                "month_december": "Prosinac"
            },
            "dropdown": {
                "action": "Akcija",
                "edit": "Uredi",
                "delete": "Izbriši"
            }
        },
        "message": {
            "maxPaymentMethodsLimitReached": "Dosegli ste ograničenje od 3 načina plaćanja. Ako želite dodati novi način plaćanja, možete to učiniti brisanjem postojećeg.",
            "success": "Način plaćanja je uklonjen!",
            "error": "Nešto je pošlo po zlu! Molimo osvježite stranicu i pokušajte ponovno!"
        },
        "modal": {
            "delete": {
                "header": "Izbriši način plaćanja {{cardNumber}}",
                "body": "Jeste li sigurni da želite izbrisati ovaj način plaćanja?"
            }
        }
    },
    "add": {
        "title": "Dodaj način plaćanja",
        "form": {
            "label": {
                "card_details": "Podaci o kartici",
                "cardholder_name": "Ime vlasnika kartice",
                "card_number": "Broj kartice",
                "expiry_month": "Mjesec isteka",
                "expiry_year": "Godina isteka (GGGG)",
                "security_code_cvc": "Sigurnosni kod (CVC)",
                "billing_details": "Podaci o naplati",
                "country": "Država",
                "street_and_number": "Ulica i kućni broj",
                "city": "Grad",
                "postal_code": "Poštanski broj"
            },
            "help_text": {
                "security_code_cvc": "Sigurnosni kod vaše kartice (CVC) je 3 ili 4 znamenkasti broj koji se nalazi na poleđini većine kartica."
            },
            "options": {
                "month": {
                    "january": "Siječanj",
                    "february": "Veljača",
                    "march": "Ožujak",
                    "april": "Travanj",
                    "may": "Svibanj",
                    "june": "Lipanj",
                    "july": "Srpanj",
                    "august": "Kolovoz",
                    "september": "Rujan",
                    "october": "Listopad",
                    "november": "Studeni",
                    "december": "Prosinac"
                },
                "expiry_month": {
                    "select": "Odaberite mjesec isteka"
                },
                "country": {
                    "select": "Odaberite državu"
                }
            },
            "button": {
                "submit": "Pošalji"
            },
            "validation": {
                "expiry_month_required": "Mjesec isteka je obavezan",
                "expiry_month_valid": "Mjesec isteka ne smije biti u prošlosti",
                "country_required": "Država je obavezna"
            }
        },
        "message": {
            "success": "Način plaćanja je dodan!",
            "error": "Nešto je pošlo po zlu! Molimo osvježite stranicu i pokušajte ponovno!"
        },
        "modal": {
            "addPaymentMethod": {
                "header": "Jeste li sigurni da želite dodati ovaj način plaćanja na svoj profil?",
                "body": "Ovim jamčite da su svi navedeni podaci istiniti. Sami ste i pravno odgovorni za navedene podatke i za istinitost tih informacija.",
                "button": {
                    "cancel": "Odustani",
                    "confirm": "Potvrdi"
                }
            }
        }
    },
    "update": {
        "title": "Ažuriraj način plaćanja",
        "form": {
            "label": {
                "card_details": "Podaci o kartici",
                "cardholder_name": "Ime vlasnika kartice",
                "card_number": "Broj kartice",
                "expiry_month": "Mjesec isteka",
                "expiry_year": "Godina isteka (GGGG)",
                "security_code_cvc": "Sigurnosni kod (CVC)",
                "billing_details": "Podaci o naplati",
                "country": "Država",
                "street_and_number": "Ulica i kućni broj",
                "city": "Grad",
                "postal_code": "Poštanski broj",
                "set_as_default": "Postavi kao zadano"
            },
            "help_text": {
                "security_code_cvc": "Sigurnosni kod vaše kartice (CVC) je 3 ili 4 znamenkasti broj koji se nalazi na poleđini većine kartica."
            },
            "options": {
                "month": {
                    "january": "Siječanj",
                    "february": "Veljača",
                    "march": "Ožujak",
                    "april": "Travanj",
                    "may": "Svibanj",
                    "june": "Lipanj",
                    "july": "Srpanj",
                    "august": "Kolovoz",
                    "september": "Rujan",
                    "october": "Listopad",
                    "november": "Studeni",
                    "december": "Prosinac"
                },
                "expiry_month": {
                    "select": "Odaberite mjesec isteka"
                },
                "country": {
                    "select": "Odaberite državu"
                }
            },
            "button": {
                "submit": "Pošalji"
            },
            "validation": {
                "expiry_month_required": "Mjesec isteka je obavezan",
                "expiry_month_valid": "Mjesec isteka ne smije biti u prošlosti",
                "country_required": "Država je obavezna"
            }
        },
        "message": {
            "success": "Način plaćanja je ažuriran!",
            "error": "Nešto je pošlo po zlu! Molimo osvježite stranicu i pokušajte ponovno!"
        },
        "modal": {
            "updatePaymentMethod": {
                "header": "Jeste li sigurni da želite ažurirati svoj način plaćanja?",
                "body": "Ovim jamčite da su svi navedeni podaci istiniti. Sami ste i pravno odgovorni za navedene podatke i za istinitost tih informacija.",
                "button": {
                    "cancel": "Odustani",
                    "confirm": "Potvrdi"
                }
            }
        }
    }
};

export default paymentMethodsHR;